<template>
  <div class="text-left">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-credit-card-outline"
          inline
        >
          <v-card-text>
            <v-row>
              <v-col
                class="xs"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="search"
                  label="ИНН, КБК, УСЛУГИ, ПОЛУЧАТЕЛИ"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :items="table.items"
                  :headers="table.headers.filter(a => a.if($store.state.user.role))"
                  :search.sync="search"
                  hide-default-header
                  hide-default-footer
                  disable-pagination
                  no-data-text="Нет данных для отображения"
                >
                  <template v-slot:body="{items}">
                    <v-container>
                      <v-row v-if="recipient.length == 0">
                        <v-col
                          class="xs"
                          cols="12"
                          md="3"
                        >
                          <v-card
                            raised
                            height="250"
                            class="text-center"
                            style="cursor:pointer"
                            @click="free_requisites"
                          >
                            <v-card-text class="black--text text-caption">
                              <v-row>
                                <v-col cols="8" />
                                <v-col
                                  class="xs"
                                  cols="12"
                                  md="4"
                                >
                                  <v-icon size="35">
                                    mdi-bank
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  Платеж по свободным реквизитам
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col
                          class="xs"
                          cols="12"
                          md="3"
                        >
                          <v-card
                            raised
                            height="250"
                            class="text-center"
                            style="cursor:pointer"
                            @click="load_payers(), charge.show = true, charge_form= {docs:[]}, charge.data = []"
                          >
                            <v-card-text class="black--text text-caption">
                              <v-row>
                                <v-col cols="8" />
                                <v-col
                                  class="xs"
                                  cols="12"
                                  md="4"
                                >
                                  <v-icon size="35">
                                    mdi-database-search
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  Поиск начислений
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col
                          v-for="(item,index) in groupBy(items, 'recipient_name')"
                          :key="'item_' + index"
                          class="xs"
                          cols="12"
                          md="3"
                        >
                          <v-card
                            raised
                            height="250"
                            class="text-center"
                            style="cursor:pointer"
                            @click="recipient = item, up()"
                          >
                            <v-card-text class="black--text text-caption">
                              <v-row>
                                <v-col cols="8" />
                                <v-col
                                  class="xs"
                                  cols="12"
                                  md="4"
                                >
                                  <v-icon size="35">
                                    {{ item[0].icon || "mdi-settings" }}
                                  </v-icon>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  {{ index }}
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-btn
                            color="secondary"
                            @click="recipient = []"
                          >
                            Назад
                          </v-btn>
                        </v-col>
                        <v-col
                          v-for="(item,index) in recipient"
                          :key="'service_' + index"
                          class="xs"
                          cols="12"
                          md="3"
                        >
                          <v-card
                            raised
                            class="text-center"
                            style="cursor:pointer"
                            color="grey lighten-3"
                            @click="form=JSON.parse(JSON.stringify(item)), dialog.show = true, dialog.create = true, dialog.view = false"
                          >
                            <v-card-actions class="mb-n10">
                              <v-row>
                                <v-col
                                  class="xs"
                                  cols="12"
                                  md="6"
                                >
                                  <v-icon size="35">
                                    {{ item.icon || "mdi-settings" }}
                                  </v-icon>
                                </v-col>
                                <v-col
                                  cols="12"
                                  md="6"

                                  class="text-bottom xs"
                                >
                                  <span class="text-caption"><b>{{ item.sum }}</b><v-icon size="15">mdi-currency-rub</v-icon></span>
                                </v-col>
                              </v-row>
                            </v-card-actions>
                            <v-card-text
                              grow
                              class="black--text text-caption"
                            >
                              <v-row style="height:170px;line-height:1">
                                <v-col cols="12">
                                  <font size="1">
                                    {{ item.name }}
                                  </font>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="text-h6"
              >
                Список получателей  и услуги
              </v-col>
            </v-row>
            <v-row>
              <v-col
                class="xs"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="search"
                  label="Получатель, инн, кбк, услуга"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :items="table.items"
                  :headers="table.headers.filter(a => a.if($store.state.user.role))"
                  :search.sync="search"
                  no-data-text="Нет данных для отображения"
                  @click:row="(item)=> {form=JSON.parse(JSON.stringify(item)), dialog.show = true, dialog.create = true, dialog.view = false}"
                >
                  <template v-slot:item.action="{item}">
                    <v-icon
                      large
                      @click="form=JSON.parse(JSON.stringify(item)), dialog.show = true, dialog.create = true, dialog.view = false"
                    >
                      mdi-credit-card-marker-outline
                    </v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </base-material-card>
      </v-col>
      <v-dialog
        v-model="dialog.show"
        persistent
      >
        <mfc-order-form
          :dialog="dialog"
          :form="form"
          :service="form.service"
        />
      </v-dialog>
      <v-dialog
        v-model="charge.show"
        persistent
      >
        <base-material-card>
          <v-card-title>Поиск начислений</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  class="mt-n5"
                >
                  <v-autocomplete
                    v-model="selected.payer"
                    prepend-icon="mdi-account-search"
                    editable
                    :filter="name_filter"
                    :items="select.payers"
                    label="Поиск клиента"
                    :readonly="dialog.view"
                    @change="payer_changed"
                  >
                    <template v-slot:selection="{item}">
                      {{ item.name }}
                    </template>
                    <template v-slot:item="{item}">
                      <v-list
                        two-line
                        class="text-left"
                      >
                        <v-list-item-content>
                          <v-list-item-title> {{ item.name }} {{ item.doc.series }}-{{ item.doc.number }}</v-list-item-title>
                          <v-list-item-subtitle>{{ item.address }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row
                v-for="(item,index) in charge_form.docs"
                :key="'charge_' + index"
              >
                <v-col
                  cols="12"
                  md="4"

                  class="mt-n5 xs"
                >
                  <v-select
                    v-model="item.type"
                    prepend-icon="mdi-passport"
                    :items="select.doc_type"
                    label="Тип поиска"
                    @change="item.series = '', item.number = ''"
                  />
                </v-col>
                <v-col
                  v-if="item.type!=100 && item.type!=14 && item.type!=21"
                  cols="12"
                  md="3"

                  class="mt-n5 xs"
                >
                  <v-text-field
                    v-model="item.series"
                    label="Серия документа"
                  />
                </v-col>
                <v-col
                  :cols="item.type==100?7:4"
                  class="mt-n5"
                >
                  <v-text-field
                    v-model="item.number"
                    :label="item.type==100?'УИН':'Номер документа'"
                    :rules="[(v) => check_doc(item.type, v) || 'Неверное значение']"
                  />
                </v-col>
                <v-col cols="1">
                  <v-icon @click="charge_form.docs = charge_form.docs.filter(a=>a!=item)">
                    mdi-delete
                  </v-icon>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"

                  class="text-left xs"
                >
                  <v-btn
                    color="primary"
                    @click="charge_form.docs.push({})"
                  >
                    Добавить документ
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  md="6"

                  class="text-right xs"
                >
                  <v-btn
                    color="secondary"
                    @click="charge_search"
                  >
                    Поиск
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    :items="charge.data"
                    :headers="table.headers2.filter(a => a.if($store.state.user.role))"
                    :search.sync="search"
                    no-data-text="Начисления по указанным документам в ГИС ГМП не найдены"
                    @click:row="(item)=> {form=JSON.parse(JSON.stringify(item)), dialog.show = true, dialog.create = true, dialog.view = false}"
                  >
                    <template v-slot:item.action="{item}">
                      <v-icon
                        large
                        @click="form=JSON.parse(JSON.stringify(item)), dialog.show = true, dialog.create = true, dialog.view = false"
                      >
                        mdi-credit-card-marker-outline
                      </v-icon>
                    </template>
                    <template v-slot:item.payer.doc="{item}">
                      {{ dict.doc_type[item.payer.doc.type] }}<br>
                      {{ item.payer.doc.series }} {{ item.payer.doc.number }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="secondary"
              @click="charge.show = false, selected.payer = null"
            >
              Закрыть
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
    </v-row>
    <v-overlay
      :value="loader.charge"
      z-index="999"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
      Идет поиск начислений...
    </v-overlay>
  </div>
</template>

<script>
  import $ from 'jquery'
  import mfcOrderForm from './Mfc-order-form.vue'
  export default {
    components: { mfcOrderForm },
    data: () => ({
      loader: {
        charge: false,
      },
      recipient: [],
      search: '',
      charge: {
        show: false,
        data: [],
      },
      dialog: {
        create: false,
        change: false,
        show: false,
        no_recipient: false,
      },
      charge_form: {
        docs: [],
      },
      filter_form: {
        name: '',
      },
      form: {
        service: '',
        recipient: {

        },
        payer: {
          doc: {
            type: '',
            series: '',
            number: '',
          },
          address: '',
          email: '',
          phone: '',
          inn: '',
        },
      },
      table: {
        headers: [
          { text: 'Действия', value: 'action', if: (role) => true },
          { text: 'Получатель', value: 'recipient_name', if: (role) => true },
          { text: 'ИНН', value: 'recipient.inn', if: (role) => true },
          { text: 'Наименование услуги', value: 'name', if: (role) => true },
          { text: 'КБК', value: 'recipient.kbk', if: (role) => true },
          { text: 'Сумма', value: 'sum', if: (role) => true },
        ],
        headers2: [
          { text: 'Действия', value: 'action', if: (role) => true },
          { text: 'Получатель', value: 'recipient.name', if: (role) => true },
          { text: 'ИНН', value: 'recipient.inn', if: (role) => true },
          { text: 'Наименование услуги', value: 'description', if: (role) => true },
          { text: 'Документ', value: 'payer.doc', if: (role) => true },
          { text: 'КБК', value: 'recipient.kbk', if: (role) => true },
          { text: 'Сумма', value: 'sum', if: (role) => true },
        ],
        items: [],
      },
      select: {
        payers: [],
        doc_type: [
          { value: '100', text: 'УИН' },
          { value: '01', text: 'Паспорт гражданина Российской Федерации' },
          { value: '02', text: 'Свидетельство о рождении' },
          { value: '03', text: 'Паспорт моряка (удостоверение личности моряка)' },
          { value: '04', text: 'Удостоверение личности военнослужащего ' },
          { value: '05', text: 'Военный билет военнослужащего' },
          { value: '06', text: 'Временное удостоверение личности гражданина Российской Федерации' },
          { value: '07', text: 'Справка об освобождении из мест лишения свободы' },
          { value: '08', text: 'Паспорт иностранного гражданина либо иной документ, установленный федеральным законом или признаваемый в соответствии с международным договором Российской Федерации в качестве документа, удостоверяющего личность иностранного гражданина' },
          { value: '09', text: 'Вид на жительство ' },
          { value: '10', text: 'Разрешение на временное проживание (для лиц без гражданства)' },
          { value: '11', text: 'Удостоверение беженца' },
          { value: '12', text: 'Миграционная карта' },
          { value: '13', text: 'Паспорт гражданина СССР' },
          { value: '14', text: 'CНИЛС' },
          { value: '21', text: 'ИНН' },
          { value: '22', text: 'Водительское удостоверение' },
          { value: '24', text: 'Свидетельство о регистрации транспортного средства в органах Министерства внутренних дел Российской Федерации' },
          { value: '25', text: 'Охотничий билет' },
          { value: '26', text: 'Разрешение на хранение и ношение охотничьего оружия' },
          { value: '28', text: 'Загранпаспорт' },
          { value: '29', text: 'Свидетельство о предоставлении временного убежища на территории Российской Федерации' },
          { value: '30', text: 'Свидетельство о рассмотрении ходатайства по существу' },
          { value: '99', text: 'Иной' },
        ],
      },
      dict: {
        doc_type: {
          '01': 'Паспорт гражданина Российской Федерации',
          '02': 'Свидетельство о рождении',
          '03': 'Паспорт моряка (удостоверение личности моряка)',
          '04': 'Удостоверение личности военнослужащего ',
          '05': 'Военный билет военнослужащего',
          '06': 'Временное удостоверение личности гражданина Российской Федерации',
          '07': 'Справка об освобождении из мест лишения свободы',
          '08': 'Паспорт иностранного гражданина либо иной документ, установленный федеральным законом или признаваемый в соответствии с международным договором Российской Федерации в качестве документа, удостоверяющего личность иностранного гражданина',
          '09': 'Вид на жительство ',
          10: 'Разрешение на временное проживание (для лиц без гражданства)',
          11: 'Удостоверение беженца',
          12: 'Миграционная карта',
          13: 'Паспорт гражданина СССР',
          14: 'CНИЛС',
          21: 'ИНН',
          22: 'Водительское удостоверение',
          24: 'Свидетельство о регистрации транспортного средства в органах Министерства внутренних дел Российской Федерации',
          25: 'Охотничий билет',
          26: 'Разрешение на хранение и ношение охотничьего оружия',
          28: 'Загранпаспорт',
          29: 'Свидетельство о предоставлении временного убежища на территории Российской Федерации',
          30: 'Свидетельство о рассмотрении ходатайства по существу',
          99: 'Иной',
        },
      },
      selected: {
        payer: null,
      },
    }),
    mounted: function () {
      this.load()
      // this.load_payers()
    },
    methods: {
      up: function () {
        $('html, body').animate({
          scrollTop: 150,
        })
      },
      load_payers: function () {
        this.axios
          .post('/api/member/list', {})
          .then(response => {
            if (!response.data.error) {
              for (const x in response.data.data) {
                response.data.data[x].docs = response.data.data[x].docs || []
                response.data.data[x].docs.push(response.data.data[x].doc)
                for (const y in response.data.data[x].docs) {
                  response.data.data[x].docs[y].type_name = this.dict.doc_type[response.data.data[x].docs[y].type]
                }
              }
              this.select.payers = response.data.data
              this.selected.payer = null
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
      check_doc: function (type, number) {
        if (type == 21) {
          const error = {}
          if (this.validateInn(number, error)) return true
          else return error.message
        }
        if (type == 14) {
          const error = {}
          if (this.validateSnils(number, error)) return true
          else return error.message
        }
        return true
      },
      validateSnils (snils, error) {
        var result = false
        if (typeof snils === 'number') {
          snils = snils.toString()
        } else if (typeof snils !== 'string') {
          snils = ''
        }
        if (!snils.length) {
          error.code = 1
          error.message = 'СНИЛС пуст'
        } else if (/[^0-9]/.test(snils)) {
          error.code = 2
          error.message = 'СНИЛС может состоять только из цифр'
        } else if (snils.length !== 11) {
          error.code = 3
          error.message = 'СНИЛС может состоять только из 11 цифр'
        } else {
          var sum = 0
          for (var i = 0; i < 9; i++) {
            sum += parseInt(snils[i]) * (9 - i)
          }
          var checkDigit = 0
          if (sum < 100) {
            checkDigit = sum
          } else if (sum > 101) {
            checkDigit = parseInt(sum % 101)
            if (checkDigit === 100) {
              checkDigit = 0
            }
          }
          if (checkDigit === parseInt(snils.slice(-2))) {
            result = true
          } else {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      validateInn: function (inn, error) {
        var result = false
        if (typeof inn === 'number') {
          inn = inn.toString()
        } else if (typeof inn !== 'string') {
          inn = ''
        }
        if (!inn.length) {
          error.code = 1
          error.message = 'ИНН пуст'
        } else if (/[^0-9]/.test(inn)) {
          error.code = 2
          error.message = 'ИНН может состоять только из цифр'
        } else if ([10, 12].indexOf(inn.length) === -1) {
          error.code = 3
          error.message = 'ИНН может состоять только из 10 или 12 цифр'
        } else {
          var checkDigit = function (inn, coefficients) {
            var n = 0
            for (var i in coefficients) {
              n += coefficients[i] * inn[i]
            }
            return parseInt(n % 11 % 10)
          }
          switch (inn.length) {
            case 10:
              var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8])
              if (n10 === parseInt(inn[9])) {
                result = true
              }
              break
            case 12:
              var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8])
              if ((n11 === parseInt(inn[10])) && (n12 === parseInt(inn[11]))) {
                result = true
              }
              break
          }
          if (!result) {
            error.code = 4
            error.message = 'Неправильное контрольное число'
          }
        }
        return result
      },
      payer_changed: function () {
        if (this.selected.payer) {
          this.charge_form.docs = this.selected.payer.docs || []
        }
      },
      name_filter: function (item, query, text) {
        if (item.name.toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.doc && item.doc.series.indexOf(query.toUpperCase()) > -1) return true
        if (item.doc && item.doc.number.indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      free_requisites: function () {
        this.form = {
          recipient: {
            name: '',
            name_full: '',
            inn: '',
            kpp: '',
            bankname: '',
            bik: '',
            ks: '',
          },
          payer: {
            doc: {
              type: '',
              series: '',
              number: '',
            },
            address: '',
            email: '',
            phone: '',
            inn: '',
          },
        }
        this.dialog.show = true
        this.dialog.create = true
        this.dialog.view = false
        this.dialog.no_recipient = true
      },
      groupBy: function (xs, key) {
        return xs.reduce(function (rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x)
          return rv
        }, {})
      },
      charge_search: function () {
        this.loader.charge = true
        for (const x in this.charge_form.docs) {
          if (this.charge_form.docs[x].type == '100') { this.charge_form.docs[x].uin = this.charge_form.docs[x].number }
        }
        this.axios
          .post('/api/order/charge', this.charge_form)
          .then(response => {
            this.loader.charge = false
            if (!response.data.error) {
              this.charge.data = response.data.data
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.message || 'Ошибка при сохранении данных'
              )
            }
          })
          .catch(e => {
            this.loader.charge = false
            this.$store.commit('snackbar', e)
          })
      },
      load: function () {
        this.axios
          .post('/api/recipient/list', this.filter_form)
          .then(response => {
            if (!response.data.error) {
              this.table.items = []
              for (const x in response.data.data) {
                for (const y in response.data.data[x].services) {
                  this.table.items.push({
                    service: response.data.data[x].services[y].id,
                    sum: response.data.data[x].services[y].sum,
                    recipient_name: response.data.data[x].name,
                    description: response.data.data[x].services[y].description,
                    name: response.data.data[x].services[y].name,
                    icon: response.data.data[x].icon,
                    service_icon: response.data.data[x].services[y].icon,
                    recipient: {
                      charge: false,
                      name: response.data.data[x].name,
                      name_full: response.data.data[x].legal.name.full,
                      inn: response.data.data[x].legal.inn,
                      kpp: response.data.data[x].legal.kpp,
                      accnumber: response.data.data[x].requisites.rs,
                      bankname: response.data.data[x].requisites.bank_name,
                      bik: response.data.data[x].requisites.bic,
                      kbk: response.data.data[x].services[y].kbk,
                      oktmo: response.data.data[x].services[y].oktmo,
                    },
                    payer: {
                      doc: {

                      },
                      docs: [],
                    },
                  })
                }
              }
            } else {
              this.$store.commit(
                'snackbar',
                response.data.data || response.data.message || 'Ошибка при сохранении данных'
              )
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', e)
          })
      },
    },
  }
</script>
